"use client";

import {
  beginPlatformAudioSuspend,
  endPlatformAudioSuspend,
} from "@/lib/audio/index";
import { syncBgmPlaybackVolume } from "@/lib/audio/play";

let initStarted = false;
let interactionSuspendDepth = 0;

function beginInteractionSuspend(): void {
  interactionSuspendDepth += 1;
  if (
    interactionSuspendDepth === 1 &&
    typeof document !== "undefined" &&
    document.body
  ) {
    document.body.style.pointerEvents = "none";
  }
}

function endInteractionSuspend(): void {
  interactionSuspendDepth = Math.max(0, interactionSuspendDepth - 1);
  if (
    interactionSuspendDepth === 0 &&
    typeof document !== "undefined" &&
    document.body
  ) {
    document.body.style.pointerEvents = "";
  }
}

/**
 * `NEXT_PUBLIC_FRVR_GAME_ID` — real id supplied by FRVR at packaging time for production.
 * @see https://docs.frvr.com/engines/web/quickstart/
 */
function frvrGameId(): string {
  const raw = import.meta.env.NEXT_PUBLIC_FRVR_GAME_ID?.trim();
  return raw && raw.length > 0 ? raw : "quiz-quest-web-dev";
}

/**
 * Assign config, lifecycle, `FRVR.init()`, and bootstrapper once per tab.
 */
export function initFrvrOnce(): void {
  if (typeof window === "undefined" || initStarted) return;
  const FRVR = window.FRVR;
  if (!FRVR) return;
  initStarted = true;

  FRVR.config = {
    gameId: frvrGameId(),
    ads: {
      throttling: {
        maxfrequency: 5 * 60 * 1000,
        initTimeBlock: 0,
      },
    },
  };

  FRVR.lifecycle.onSuspend = () => {
    beginInteractionSuspend();
  };
  FRVR.lifecycle.onResume = () => {
    endInteractionSuspend();
  };
  FRVR.lifecycle.onAudioSuspend = () => {
    beginPlatformAudioSuspend();
    syncBgmPlaybackVolume();
  };
  FRVR.lifecycle.onAudioResume = () => {
    endPlatformAudioSuspend();
    syncBgmPlaybackVolume();
  };
  // TODO: route to in-game pause UI when a global pause exists.
  FRVR.lifecycle.onGamePause = () => {};

  FRVR.init();
}

export async function runFrvrBootstrapper(): Promise<void> {
  if (typeof window === "undefined") return;
  const FRVR = window.FRVR;
  if (!FRVR?.bootstrapper?.init) return;
  try {
    await FRVR.bootstrapper.init();
    FRVR.bootstrapper.setProgress(1);
    FRVR.bootstrapper.complete();
  } catch {
    /* CDN / channel hiccup — app continues without splash */
  }
}
